import { DateFormats, formatDate } from '@strata/helper-functions';
import { ReasonInput } from '@strata/react-compound-inputs';
import { DateInputFormik } from '@strata/react-date-time';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { validationStrings } from '@strata/strata-ui-strings';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { addPerformanceRequirement } from 'api/performanceAPI';
import { getAddableValueCases } from 'services/valueCaseHelpers';
import { useGetValueCasesQuery } from 'store/api/performanceApi';

const ReasonOptions = ['Missed at Auction', 'Payer Request'];
const INDIVIDUAL = 'INDIVIDUAL';

export const UpdateReferralDataAddPerformance = ({
    referralDetails = undefined,
    performanceEntries = undefined,
}) => {
    const { data: valueCases, isFetching } = useGetValueCasesQuery();
    const valueCaseOptions = getAddableValueCases({
        valueCases,
        referralDetails,
        performanceEntries,
    }).map(({ valueCaseName, valueCaseId }) => ({ name: valueCaseName, value: valueCaseId }));

    return (
        <>
            <SuggestSingleSelectFormik
                id="valueCase"
                label="Performance Requirement to Add"
                required
                isLoading={isFetching}
                values={valueCaseOptions}
                helperText="Only value cases configured for this referral's health plan and product are listed."
            />
            <DateInputFormik
                id="performanceStartDate"
                label="Performance Start Date"
                required
                helperText="The performance and evaluation end dates are calculated from this date using the value case configuration."
            />
            <ReasonInput reasons={ReasonOptions} />
        </>
    );
};

UpdateReferralDataAddPerformance.propTypes = {
    referralDetails: PropTypes.shape({
        segmentId: PropTypes.string,
        productServiceOid: PropTypes.string,
    }),
    performanceEntries: PropTypes.arrayOf(PropTypes.shape({})),
};

UpdateReferralDataAddPerformance.initialValues = () => ({});

UpdateReferralDataAddPerformance.validationSchema = {
    valueCase: Yup.object().required(validationStrings.requiredField.errorMessage),
    performanceStartDate: DateInputFormik.validator().required(
        validationStrings.requiredField.errorMessage,
    ),
    ...ReasonInput.validationSchema,
};

UpdateReferralDataAddPerformance.onSubmit = async ({ values, referralDetails, username }) =>
    addPerformanceRequirement({
        referral_id: referralDetails?.referralId,
        value_case_id: values.valueCase.value,
        performance_start_date: formatDate(values.performanceStartDate, DateFormats.HYPHEN_DATE),
        username,
        ...ReasonInput.submitValues(values),
        reason: values.reason,
        attachment_method: INDIVIDUAL,
    });
